import { FC } from 'react'
import BaseError from './BaseError'

const BadRequestError: FC<{ onClose: () => void }> = ({ onClose }) => {
  return (
    <BaseError
      onClose={onClose}
      header="We’re Experiencing Technical Difficulties"
      message={
        <>
          Please try again in a few minutes. If the problem persists, contact
          Customer Support at <strong>(844) 552-7444</strong> or{' '}
          <strong>support@brightmls.com</strong> for assistance.
        </>
      }
    />
  )
}

export default BadRequestError
